<template>
<div class="dropdown-divider"></div>
</template>

<script>
export default {
    
}
</script>